import { Clear, FilterAlt } from '@mui/icons-material'
import {
  Button,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Popover,
  Stack,
  Switch,
  Typography,
} from '@mui/material'
import { ChangeEvent, FC, useEffect, useState } from 'react'
import { useApprovalReportsFilter } from 'src/features/approvals/hooks/useApprovalReportsFilter'

const ApprovalReportsFilterDropDown: FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isOpen = anchorEl !== null
  const [reportName, setReportName] = useState<string>('')
  const [isInvalid, setIsInvalid] = useState<number>(0)
  const [user, setUser] = useState<string>('')

  const { uiFilter, updateFilter } = useApprovalReportsFilter()

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- FIXME: eslint-plugin-react-hooks が 7.0.1 にバージョンアップした際にエラーになるようになったため一旦無視。ここのコードを触る際に修正してください🙏
    setReportName(uiFilter?.reportName ?? '')
    setIsInvalid(uiFilter?.isInvalid ?? 0)
    setUser(uiFilter?.user ?? '')
  }, [uiFilter?.reportName, uiFilter?.isInvalid, uiFilter?.user])

  const isFilterOn = () => {
    return reportName.length > 0 || isInvalid === 1 || user.length > 0
  }

  const clearFilter = () => {
    setReportName('')
    setIsInvalid(0)
    setUser('')
    updateFilter({
      reportName: '',
      isInvalid: 0,
      user: '',
    })
  }

  const handleReportNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value
    setReportName(newValue)
    updateFilter({ reportName: newValue })
  }

  const handleIsInvalidChange = (_: unknown, checked: boolean) => {
    const newIsInvalid = checked ? 1 : 0
    setIsInvalid(newIsInvalid)
    updateFilter({ isInvalid: newIsInvalid })
  }

  const handleUserChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value
    setUser(newValue)
    updateFilter({ user: newValue })
  }

  return (
    <>
      <Button
        color={isFilterOn() ? 'filtered' : 'secondary'}
        variant="outlined"
        startIcon={<FilterAlt />}
        onClick={({ currentTarget }) => setAnchorEl(currentTarget)}
      >
        絞り込み: {isFilterOn() ? 'ON' : 'OFF'}
      </Button>
      <Popover
        id="approval-reports-filter-popover"
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{
          paper: { sx: { padding: 2, width: '100%', maxWidth: 400 } },
        }}
      >
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="flex-end">
            <Button onClick={clearFilter}>クリア</Button>
          </Stack>
          <Stack>
            <Typography variant="subtitle1">レポート名</Typography>
            <OutlinedInput
              fullWidth
              size="small"
              value={reportName}
              onChange={handleReportNameChange}
              endAdornment={
                reportName && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      edge="end"
                      onClick={() => {
                        setReportName('')
                        updateFilter({ reportName: '' })
                      }}
                    >
                      <Clear fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )
              }
            />
          </Stack>
          <Stack>
            <Typography variant="subtitle1">逸脱有無</Typography>
            <Switch
              checked={isInvalid === 1}
              onChange={handleIsInvalidChange}
            />
          </Stack>
          <Stack>
            <Typography variant="subtitle1">依頼者</Typography>
            <OutlinedInput
              fullWidth
              size="small"
              value={user}
              onChange={handleUserChange}
              endAdornment={
                user && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      edge="end"
                      onClick={() => {
                        setUser('')
                        updateFilter({ user: '' })
                      }}
                    >
                      <Clear fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )
              }
            />
          </Stack>
        </Stack>
      </Popover>
    </>
  )
}

export default ApprovalReportsFilterDropDown
